import { combineReducers } from 'redux'

import { requestFeatureProfile } from './requestFeature'

export const requestFeatureReducer = combineReducers({
  requestFeatureProfile
})
